document.addEventListener('turbo:load', function () {
  const extractedTempPageUri = location.href.split('/').slice(3, 6).join('/');
  const tempPageUri = 'google_workspace/temporary_page/new';

  if (extractedTempPageUri === tempPageUri) {
    const serverEventsUri = '/google_workspace/integrations/new';
    const serverConnection = new EventSource(serverEventsUri);

    serverConnection.addEventListener('ping', function (event) {
      const message = JSON.parse(event.data);

      if (message['finished'] === 'true') {
        serverConnection.close();

        //
        // When User opens business units page, we want them to see the new
        // count of tenants in the building.
        // More often then not, it happens that a business unit page refresh is
        // needed because Core hasn't yet created tenants in the building.
        // By waiting a bit more we can safely circumvent the issue and optimize
        // the experience.
        //
        // Time to wait: 2500 ms/2 sec
        //
        setTimeout(() => {
          window.location.href = message['origin_url'];
        }, 2500);
      }
    });
  }
});
